import './style.scss';
import 'swiper/swiper.scss';
import Swiper from "swiper";
import { Navigation } from 'swiper/modules';

export function resources_slider_block() {

    const blocks = document.querySelectorAll('.resources_slider_block');
    if (!blocks.length) return;

    blocks.forEach((block) => {

        const swiperContainer = block.querySelector('.resources-swiper');
        if (!swiperContainer) return;

        const nextBtn = block.querySelector('.swiper-button-next');
        const prevBtn = block.querySelector('.swiper-button-prev');

        const slideCount = swiperContainer.querySelectorAll('.swiper-slide').length;

        const hideNav = () => {
            if (nextBtn) nextBtn.style.display = "none";
            if (prevBtn) prevBtn.style.display = "none";
        };

        const w = window.innerWidth;

        if (w >= 1440 && slideCount <= 4) hideNav();
        else if (w >= 992 && w < 1440 && slideCount <= 3) hideNav();
        else if (w >= 768 && w < 992 && slideCount <= 2) hideNav();
        else if (w < 768 && slideCount <= 1) hideNav();

        new Swiper(swiperContainer, {
            slidesPerView: 1.158,
            spaceBetween: 26,
            slidesOffsetAfter: 44,
            speed: 800,

            breakpoints: {
                768: { slidesPerView: 2.21 },
                992: { slidesPerView: 2.95 },
                1280: { slidesPerView: 3.66 },
                1440: { slidesPerView: 4.12 },
                1920: { slidesPerView: 5.1 },
            },

            modules: [Navigation],
            navigation: {
                nextEl: nextBtn,
                prevEl: prevBtn,
            },
        });

    });
}
